
import Vue from 'vue';
import LicenciaService from '@/services/LicenciaService';

export default Vue.extend({
    name: 'LicenciaActual',
    props: {
        dialogBusqueda: {
            type: Boolean,
            default: false 
        },
        locacion: {
            type: Object,
            default: null as any
        },
    },
    data: () => ({
        dialogAlerta: false,
    }),
    methods: {
        success() {
            this.$emit('success');
        },
        fail() {
            this.dialogAlerta = false;
            this.$emit('fail');
        },
        close() {
            this.$emit('close');
        },
        getHistoricoLicencia() {
            LicenciaService.getHistoricoLicencia(this.locacion.external_id)
            .then((response) => {
                let data = response.data;
                let condicion = null;
                if (data) {
                    condicion = data.find((element: any) => {
                        return element.anio === new Date().getFullYear();
                    })
                    if (condicion) {
                        this.success();
                        this.close();
                        this.$toast.success('Licencia del año actual encontrada exitosamente');
                    } else {
                        this.dialogAlerta = true;
                        this.$toast.error('Licencia del año actual no encontrada');
                    }
                } else {
                    this.dialogAlerta = true;
                    this.$toast.error('No se ha encontrado la licencia de este año');
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
    },
});
